import { render } from "./Paperclip.vue.js?vue&type=template&id=078bed0c!=!../vue-loader/dist/index.js??ruleSet[0]!./Paperclip.vue?vue&type=template&id=078bed0c"
import script from "./Paperclip.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Paperclip.vue?vue&type=script&lang=js"
export * from "./Paperclip.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Paperclip.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__